<template>
  <div>
    <v-expansion-panels v-model="expandedPanel" accordion flat>
      <v-expansion-panel style="padding: 0; background: transparent;">
        <v-expansion-panel-header class="chevron-right">
          {{ $t(headerText) }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            v-for="item in orderDetails.items"
            :key="`${restaurantName}-order-item-${item.id}`"
            class="order-item-wrapper d-flex flex-column mt-5"
          >
            <OrderItem
              :item-key="item.id"
              :name="item.name"
              :quantity="item.quantity"
              :modifiers="item.modifiers"
              :price="item.price"
              :is-paid="item.is_delivered"
              hide-modifiers
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import OrderItem from '@/components/Orders/OrderItem.vue';

export default {
  name: 'OrderItemsExpansion',
  components: {
    OrderItem,
  },
  props: {
    orderDetails: {
      type: Object,
      required: true,
    },
    restaurantName: {
      type: String,
      required: true,
    },
    expandedByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedPanel: this.expandedByDefault ? 0 : null, // null means collapsed, 0 means first panel expanded
    };
  },
  computed: {
    isExpanded() {
      return this.expandedPanel === 0;
    },
    headerText() {
      return this.isExpanded
        ? 'screens.foodCourtOrder.items.collapse'
        : 'screens.foodCourtOrder.items.expand';
    },
  },
};
</script>

<style lang="scss" scoped>
// Remove padding from expansion panel content wrapper
::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

// Also ensure the expansion panel content itself has no padding
::v-deep .v-expansion-panel-content {
  padding: 0 !important;
}

::v-deep .v-expansion-panel-header {
  padding: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
}

// Move chevron to the right side
::v-deep .chevron-right {
  flex-direction: row-reverse;
  justify-content: flex-end;

  .v-expansion-panel-header__icon {
    margin-left: 0;
    margin-right: 4px;
    order: 2;
  }
}

// Add 20px gap between order items
.order-item-wrapper {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
